import { sharedSchema } from "@shared-database/pgSchema";
import { text, timestamp, foreignKey, unique } from "drizzle-orm/pg-core";
import { Account } from "@shared-database/models/account";

export const AccountSession = sharedSchema.table(
  "AccountSession",
  {
    id: text("id").notNull(),
    providerId: text("providerId").notNull(),
    lastVisitedUrl: text("lastVisitedUrl").notNull(),
    lastActionTimestamp: timestamp("lastActionTimestamp", {
      mode: "date",
    })
      .notNull()
      .defaultNow(),
  },
  (table) => [
    unique().on(table.id, table.providerId),
    foreignKey({
      columns: [table.id, table.providerId],
      foreignColumns: [Account.providerAccountId, Account.provider],
    }).onDelete("cascade"),
  ],
);
